module.exports = __webpack_public_path__ + "static/media/fortnite.34ea6803.png";